import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useTranslation } from 'react-i18next';


const DriverSelector = ({ selectedDriver, setSelectedDriver }) => {
    const { t } = useTranslation();

    const [drivers, setDrivers] = useState([]);

    useEffect(() => {
        axios.get("https://godrive.com.pl/api/users")
            .then((res) => {
                const formattedDrivers = res.data.map((driver) => ({
                    value: driver.id,
                    label: `${driver.firstName} ${driver.lastName}`
                }));
                setDrivers(formattedDrivers);
            })
            .catch((err) => console.error("Помилка завантаження списку водіїв:", err));
    }, []);

    return (
        <Select
            options={drivers}
            value={drivers.find(driver => driver.value === selectedDriver?.value) || null} // Переконуємось, що вибір правильний
            onChange={(selectedOption) => setSelectedDriver(selectedOption)}
            placeholder={t("chooseDriver")}
            isClearable
            isSearchable
        />
    );
};

export default DriverSelector;